import * as React from "react";
import Layout from "../components/Layout";
import { Box, Center, Text } from "@chakra-ui/react";
import { Link } from "gatsby";

// markup
const NotFoundPage = () => {
  return (
    <Layout headerTheme="light">
      <Center
        minHeight="100vh"
        flexDirection="column"
        bg="linear-gradient(0deg, rgba(11,52,145,1) 0%, rgba(18,24,71,1) 100%)"
        color="White"
        textAlign="center"
      >
        <Text fontSize="xl" mb="0.2em">
          Not found
        </Text>
        <Text fontSize="4xl" mb="1em">
          Page not found
        </Text>
        <Text fontSize="lg">
          Sorry{" "}
          <Box as="span" role="img" aria-label="Pensive emoji">
            😔
          </Box>{" "}
          we couldn’t find what you were looking for.
          <br />
          <Link to="/">Go home</Link>.
        </Text>
      </Center>
    </Layout>
  );
};

export default NotFoundPage;
